"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataViewProvider = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var PropTypes = _interopRequireWildcard(require("prop-types"));

var _lodash = _interopRequireWildcard(require("lodash"));

var _antd = require("antd");

var _DataViewContext = require("./DataViewContext");

var _filters = require("../../constants/filters");

var _selectors = require("../../store/apiFlow/data/selectors");

var _selector = require("../../store/data/value/selector");

var _selectors2 = require("../../store/filters/value/selectors");

var _actions = require("../../store/data/views/actions");

var _actions2 = require("../../store/data/filters/actions");

var _treeChanges = _interopRequireDefault(require("tree-changes"));

var _selectors3 = require("../../store/data/views/selectors");

var _store = require("store");

var _component = require("../../constants/component");

var _FilterFormProvider = require("../FilterForm/FilterFormProvider");

var _reactSpinners = require("react-spinners");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var dataSourceShape = PropTypes.shape({
  url: PropTypes.string,
  mapping: PropTypes.func
});

var getCompatibleDataType = function getCompatibleDataType(props) {
  var dataType = _lodash["default"].get(props, _component.PROPS.DATA_TYPE);

  var dataSource = _lodash["default"].get(props, _component.PROPS.DATA_SOURCE);

  if (dataType !== undefined) {
    if (_typeof(dataSource) === 'object') {
      dataType = Object.assign({}, dataSource, {
        type: dataType
      });
    }

    if (_typeof(dataType) === 'object' && _lodash["default"].has(dataType, 'type')) {
      return dataType;
    }
  }
};

var DataViewProvider = function DataViewProvider(WrappedComponent, dataSource) {
  var _DataViewProvider$pro;

  var DataViewProvider =
  /*#__PURE__*/
  function (_Component) {
    _inherits(DataViewProvider, _Component);

    _createClass(DataViewProvider, [{
      key: "getStoredProps",
      value: function getStoredProps(props) {
        var _this2 = this;

        var viewProps = _lodash["default"].pickBy(props, function (v, k) {
          return _lodash["default"].includes(_this2.storedProps, k);
        });

        viewProps[_component.PROPS.DATA_TYPE] = getCompatibleDataType(props);
        return viewProps;
      }
    }, {
      key: "storedProps",
      get: function get() {
        return [_component.PROPS.DATA_TYPE, _component.PROPS.FILTER_TYPE, _component.PROPS.RELATED_FILTERS];
      }
    }]);

    function DataViewProvider(props) {
      var _this;

      _classCallCheck(this, DataViewProvider);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(DataViewProvider).call(this, props));
      var dataType = getCompatibleDataType(props);

      if (dataType !== undefined) {
        var id = (0, _selectors3.getNextId)(_store.store.getState());
        _this.state = {
          id: id
        };
        props.create(id, _this.getStoredProps(props));
      }

      return _this;
    }

    _createClass(DataViewProvider, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var dataType = getCompatibleDataType(this.props);

        if (dataType !== undefined) {
          var _mount = this.props.mount;
          var id = this.state.id;

          _mount(id, this.getStoredProps(this.props));
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps, prevState, snapshot) {
        var dataType = getCompatibleDataType(this.props);

        if (dataType !== undefined) {
          var _updateProps = this.props.updateProps;
          var id = this.state.id;
          var prevDataType = getCompatibleDataType(prevProps);
          var dataSourceChanges = (0, _treeChanges["default"])(dataType, prevDataType);

          if (dataSourceChanges.changed('type') || dataSourceChanges.changed('url') || dataSourceChanges.changed('queryParams')) {
            _updateProps(id, this.getStoredProps(this.props));
          }
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        var dataType = getCompatibleDataType(this.props);

        if (dataType !== undefined) {
          var id = this.state.id;
          var _unmount = this.props.unmount;

          _unmount(id);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var dataType = getCompatibleDataType(this.props);

        if (dataType !== undefined) {
          var isDataLoading = this.props.isDataLoading;
          var id = this.state.id;

          var spinIcon = _react["default"].createElement(_reactSpinners.ScaleLoader, {
            size: 60,
            color: '#0052cc',
            css: 'top: 50%; position: relative;'
          });

          return _react["default"].createElement(_DataViewContext.DataViewContext.Provider, {
            value: {
              dataViewId: id,
              dataType: dataType
            }
          }, _react["default"].createElement(_antd.Spin, {
            spinning: isDataLoading,
            indicator: spinIcon
          }, _react["default"].createElement(WrappedComponent, _extends({}, this.props, {
            id: id
          }))));
        } else {
          return _react["default"].createElement(WrappedComponent, this.props);
        }
      }
    }]);

    return DataViewProvider;
  }(_react.Component);

  DataViewProvider.propTypes = (_DataViewProvider$pro = {
    loadData: PropTypes.bool
  }, _defineProperty(_DataViewProvider$pro, _component.PROPS.DATA_TYPE, PropTypes.any), _defineProperty(_DataViewProvider$pro, _component.PROPS.DATA_SOURCE, dataSourceShape), _defineProperty(_DataViewProvider$pro, _component.PROPS.FILTER_TYPE, PropTypes.oneOf(_lodash["default"].values(_filters.FILTER_TYPE))), _defineProperty(_DataViewProvider$pro, _component.PROPS.RELATED_FILTERS, PropTypes.arrayOf(PropTypes.oneOf((0, _lodash.values)(_filters.FILTER_TYPE)))), _defineProperty(_DataViewProvider$pro, "create", PropTypes.func.isRequired), _defineProperty(_DataViewProvider$pro, "mount", PropTypes.func.isRequired), _defineProperty(_DataViewProvider$pro, "unmount", PropTypes.func.isRequired), _defineProperty(_DataViewProvider$pro, "updateProps", PropTypes.func.isRequired), _defineProperty(_DataViewProvider$pro, "applyDataFilter", PropTypes.func.isRequired), _defineProperty(_DataViewProvider$pro, "resetDataFilter", PropTypes.func.isRequired), _DataViewProvider$pro);
  DataViewProvider.defaultProps = {
    loadData: true
  };

  var mapStateToProps = function mapStateToProps(state, props) {
    var dataType = getCompatibleDataType(props);

    if (dataType) {
      return {
        state: state,
        isDataLoading: (0, _selectors.getIsFetching)(state, dataType.type),
        isDateLoadingError: (0, _selectors.getIsError)(state, dataType.type),
        data: (0, _selector.getValue)(state, dataType.type),
        filterValues: (0, _selectors2.getValue)(state, props.filterType),
        dataSource: props.dataSource ? props.dataSource : dataSource
      };
    } else {
      return {
        state: state,
        isDataLoading: false,
        isDateLoadingError: false
      };
    }
  };

  var mapDispatchToProps = {
    create: _actions.create,
    mount: _actions.mount,
    unmount: _actions.unmount,
    updateProps: _actions.updateProps,
    applyDataFilter: _actions2.apply,
    satDataFilter: _actions2.set,
    resetDataFilter: _actions2.reset
  };
  return (0, _FilterFormProvider.FilterFormProvider)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DataViewProvider));
};

exports.DataViewProvider = DataViewProvider;